import SectionTitle from "@/components/base/SectionTitle";
import MovieCard from "@/components/base/MovieCard";
import type { Movie } from "@/mocks/movies";

interface FeaturedMoviesProps {
  movies: Movie[];
}

export default function FeaturedMovies({ movies }: FeaturedMoviesProps) {
  return (
    <section className="w-full border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 lg:px-10">
        <SectionTitle
          eyebrow="精选推荐"
          title="值得熬夜看完的午夜片"
          description="结合评分、口碑与午夜观影氛围精选出的作品，封面点击即可查看完整资料与观看建议。"
          actionLabel="进入分类页"
          actionTo="/category"
        />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4">
          {movies.map((movie, index) => (
            <MovieCard key={movie.id} movie={movie} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}